import './DatePicker.scss'
import { useCallback, useEffect } from 'react'
import { makeStyles } from '@fluentui/react-components'
import { DatePicker as D, DatePickerProps } from '@fluentui/react-datepicker-compat'
import { dateToString } from '@/util'

const useStyles = makeStyles({
  control: {
    maxWidth: '300px',
  },
})

function DatePicker(props: DatePickerProps) {
  const styles = useStyles()

  const formatDate = useCallback((date: Date | null | undefined) => {
    if (!date) return 'No date'
    return dateToString(date)
  }, [])

  // Hook to ensure popover styling. This is a very hacky solution.
  // It's the only way I could find to ensure the popover is white.
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const element = node as Element

            // Check if this might be a date picker popover
            if (
              element.querySelector('[role="dialog"]') ||
              element.querySelector('[role="grid"]') ||
              element.querySelector('button[role="gridcell"]') ||
              element.getAttribute('data-portal-node') ||
              element.getAttribute('data-portal-mode')
            ) {
              // Apply white background styling
              const popoverElement = element as HTMLElement
              popoverElement.style.backgroundColor = 'white'
              popoverElement.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.12)'
              popoverElement.style.border = '1px solid #d1d1d1'
              popoverElement.style.borderRadius = '4px'

              // Also style any child elements that might be the actual calendar
              const childElements = popoverElement.querySelectorAll('div')
              childElements.forEach((child) => {
                if (child.querySelector('[role="grid"]') || child.querySelector('button[role="gridcell"]')) {
                  ;(child as HTMLElement).style.backgroundColor = 'white'
                }
              })
            }
          }
        })
      })
    })

    // Start observing
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    })

    return () => observer.disconnect()
  }, [])

  return (
    <D {...props} className={styles.control} placeholder="Select a date..." allowTextInput formatDate={formatDate} />
  )
}

export default DatePicker

//** Leaving a list of potentially useful DatePickerProps here */
// VALUE/FORMAT RELATED
// parseDateFromString={(dateStr) => Date | null}
// value={null}
// onChange={(e) => {}}
// onSelectDate={(date) => {}}

// VALIDATION RELATED
// required
// onValidationResult={(data) => {}}
// defaultDatePickerErrorStrings for validation error messages

// APPEARANCE RELATED
// size="medium"
// appearance="outline"
// underlined={false}
// contentBefore={<div>Hello</div>}
// contentAfter={<div>Bye</div>}
// positioning={}
// firstDayOfWeek={0}
// minDate
// maxDate
